import { FC, useMemo } from 'react';
import { Flex } from '@chakra-ui/react';

import useFeatureFlagsSwitcher, {
  FeatureFlagsKey,
} from 'common/hooks/useFeatureFlagsSwitcher';
import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';
// Needed to display flag status per environment
// eslint-disable-next-line no-restricted-imports
import { ALL_FEATURE_FLAGS } from 'featureFlags';
import * as Layout from 'layouts/ContentLayout';

import { FeatureFlagsSection } from './components/FeatureFlagsSection';
import locales from './locales';
import { sortFlagKeys } from './utils';

const Settings: FC = () => {
  const { featureFlags, reset } = useFeatureFlagsSwitcher();

  const [
    sortedWipFeatureFlagsKeys,
    sortedQAFeatureFlagsKeys,
    sortedReleasedFeatureFlagsKeys,
  ] = useMemo(() => {
    const wipFlags: FeatureFlagsKey[] = [];
    const qaFlags: FeatureFlagsKey[] = [];
    const releasedFlags: FeatureFlagsKey[] = [];

    (Object.keys(featureFlags) as FeatureFlagsKey[]).forEach((flagKey) => {
      if (ALL_FEATURE_FLAGS.production[flagKey]) {
        releasedFlags.push(flagKey);
        return;
      }

      if (ALL_FEATURE_FLAGS.staging[flagKey]) {
        qaFlags.push(flagKey);
        return;
      }

      wipFlags.push(flagKey);
    });

    return [
      sortFlagKeys(wipFlags),
      sortFlagKeys(qaFlags),
      sortFlagKeys(releasedFlags),
    ];
  }, [featureFlags]);

  return (
    <Layout.Root>
      <Layout.Body size="md">
        <Layout.Header title={locales.title}></Layout.Header>

        <Callout marginBottom="space-24" variant="info">
          <Callout.Title>{locales.callout.title}</Callout.Title>
          <Callout.Content>{locales.callout.content}</Callout.Content>
        </Callout>

        <FeatureFlagsSection
          flagsKeys={sortedWipFeatureFlagsKeys}
          title={locales.wipTitle}
        />
        <FeatureFlagsSection
          flagsKeys={sortedQAFeatureFlagsKeys}
          title={locales.qaTitle}
        />
        <FeatureFlagsSection
          flagsKeys={sortedReleasedFeatureFlagsKeys}
          title={locales.releasedTitle}
        />

        <Flex justifyContent="flex-end" marginTop="space-24">
          <Button onClick={reset}>{locales.reset}</Button>
        </Flex>
      </Layout.Body>
    </Layout.Root>
  );
};

export default Settings;
